module.exports = __webpack_public_path__ + "static/media/client-influapp.f412f30a.png";